// Reforge Converter - Landing Page JavaScript (ES Modules Entry Point)

// Import all modules
import { loadConfig } from './modules/config.js';
import { initializeStripe, handleCheckout, handleDownload, handleEnterpriseInquiry } from './modules/stripe.js';
import { initializeTurnstile } from './modules/turnstile.js';
import { initFormPersistence, initMobileReminderForm } from './modules/forms.js';
import { initCookieConsent, acceptCookies, declineCookies } from './modules/cookies.js';
import { initFaqAccordion } from './modules/faq.js';
import { initScrollAnimations, initTerminal } from './modules/animations.js';
import { toggleBilling, adjustSeats, updateProfessionalPrice } from './modules/pricing.js';
import { checkout, closeCheckoutModal, openEnterpriseModal, closeEnterpriseModal } from './modules/modals.js';
import { toggleMobileMenu, setupEventListeners } from './modules/navigation.js';
import { hideToast } from '../shared/js/toast.js';
import { initDeclarativeActions } from '../shared/js/inline-actions.js';

const bootstrap = window.__REFORGE_BOOTSTRAP__ || {};
const flags = bootstrap.flags || {};
const isSiteV2Enabled = flags.site_v2 !== false;

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', async () => {
    document.documentElement.setAttribute('data-site-version', isSiteV2Enabled ? 'v2' : 'v1');

    initDeclarativeActions();
    initCookieConsent();
    initFaqAccordion();
    initFormPersistence();
    initMobileReminderForm();
    setupEventListeners();
    initScrollAnimations();
    initTerminal();

    // Load runtime config after core interactions are already live.
    await loadConfig();
    updateProfessionalPrice();
    initializeStripe();
    initializeTurnstile();
});

// Expose functions to global scope for inline HTML handlers
window.toggleMobileMenu = toggleMobileMenu;
window.toggleBilling = toggleBilling;
window.checkout = checkout;
window.closeCheckoutModal = closeCheckoutModal;
window.handleCheckout = handleCheckout;
window.handleDownload = handleDownload;
window.acceptCookies = acceptCookies;
window.declineCookies = declineCookies;
window.hideToast = hideToast;
window.openEnterpriseModal = openEnterpriseModal;
window.closeEnterpriseModal = closeEnterpriseModal;
window.handleEnterpriseInquiry = handleEnterpriseInquiry;
window.adjustSeats = adjustSeats;

// Billing toggle helper — sets the hidden checkbox state then fires toggleBilling().
// Used by data-onclick="setTog('annual')" / data-onclick="setTog('monthly')".
window.setTog = function(period) {
    const toggle = document.getElementById('billingToggle');
    if (toggle) {
        toggle.checked = (period === 'annual');
        toggleBilling();
    }
};

// WPF mockup settings toggle — called via data-onclick on the app mockup panel.
window.toggleWpfSetting = function() {
    this.classList.toggle('on');
};
